/**
* AssetLibrary.js
* 
* Created on 1-okt-2013, 15:04:03
*
* @author Ivo Swartjes for Ranj
**/

import { isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";

export default class AssetLibrary {
    constructor() {
        this._assets = {};
    };

    getAsset(id) {
        return this._assets[id];
    }

    hasAsset(id) {
        return !isNull(this._assets[id]);
    }

    addAsset(id, asset) {
        this._assets[id] = asset;
    }

    /**
     * Gets a bitmap from imageId.
     * Returns an empty container if no image with given image id was found.
     * @param {string} imageId 
     * @returns {createjs.Bitmap}
     */
    tryGetBitmapFromImageId(imageId) {
        const image = this.getAsset(imageId);
        if (!image) {
            console.warn(`Image not found! Returning empty container...`, imageId);
            return new createjs.Container();
        }

        return new createjs.Bitmap(image);
    }
}